module.exports = __webpack_public_path__ + "static/media/logo.ba8e2983.svg";